"use client";
import { jsx as s } from "react/jsx-runtime";
import l from "clsx";
import { memo as _ } from "react";
import { Box as a } from "../../base/Base.js";
import '../../../assets/PlateProcessStatus.css';const p = "_plate_197pl_1", m = "_center_197pl_9", x = "_text_197pl_13", d = "_wide_197pl_23", w = "_flex_197pl_26", f = "_white_197pl_31", y = "_violet_197pl_34", P = "_orange_197pl_37", g = "_gray_197pl_40", h = "_animcolor_197pl_44", u = "_process_line_box_197pl_66", v = "_process_line_197pl_66", e = {
  plate: p,
  center: m,
  text: x,
  wide: d,
  flex: w,
  white: f,
  violet: y,
  orange: P,
  gray: g,
  animcolor: h,
  "color-text-flow": "_color-text-flow_197pl_1",
  process_line_box: u,
  process_line: v
}, N = _(
  ({ center: t, children: o }) => /* @__PURE__ */ s(a, { gap: 8, className: l(e.plate, { [e.center]: t }), children: o })
);
N.displayName = "PlateProcessStatus";
const b = _(
  ({ text: t, center: o, wide: c, flex: r, color: n = "white", ...i }) => /* @__PURE__ */ s(
    "div",
    {
      className: l(e.text, e[n], {
        [e.center]: o,
        [e.wide]: c,
        [e.flex]: r
      }),
      ...i,
      children: t
    }
  )
);
b.displayName = "ProcessStatusText";
const S = _(
  ({ width: t, color: o = "violet" }) => /* @__PURE__ */ s("div", { className: e.process_line_box, children: /* @__PURE__ */ s(
    "div",
    {
      className: l(e.process_line, e[o], {
        [e.width]: t
      }),
      style: { width: `${t}%` }
    }
  ) })
);
S.displayName = "ProcessLine";
export {
  N as PlateProcessStatus,
  S as ProcessLine,
  b as ProcessStatusText
};
